import { render } from "./VisualMapping.vue?vue&type=template&id=2fc14456&scoped=true"
import script from "./VisualMapping.vue?vue&type=script&lang=js"
export * from "./VisualMapping.vue?vue&type=script&lang=js"

import "./VisualMapping.vue?vue&type=style&index=0&id=2fc14456&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc14456"]])

export default __exports__